// extracted by mini-css-extract-plugin
export default {"tab_header":"TabHeader_tab_header__phCCY"};